export const EligibilityActionTypes = {
  FETCH_RULE_SETS: 'eligibility/FETCH_RULE_SETS',
  FETCH_RULE_SETS_SUCCESS: 'eligibility/FETCH_RULE_SETS_SUCCESS',
  FETCH_RULE_SETS_FAILURE: 'eligibility/FETCH_RULE_SETS_FAILURE',

  SAVE_RULE_SET: 'eligibility/SAVE_RULE_SET',
  SAVE_RULE_SET_SUCCESS: 'eligibility/SAVE_RULE_SET_SUCCESS',
  SAVE_RULE_SET_FAILURE: 'eligibility/SAVE_RULE_SET_FAILURE',

  DELETE_RULE_SET: 'eligibility/DELETE_RULE_SET',
  DELETE_RULE_SET_SUCCESS: 'eligibility/DELETE_RULE_SET_SUCCESS',
  DELETE_RULE_SET_FAILURE: 'eligibility/DELETE_RULE_SET_FAILURE',

  PREVIEW_ELIGIBILITY: 'eligibility/PREVIEW_ELIGIBILITY',
  PREVIEW_ELIGIBILITY_SUCCESS: 'eligibility/PREVIEW_ELIGIBILITY_SUCCESS',
  PREVIEW_ELIGIBILITY_FAILURE: 'eligibility/PREVIEW_ELIGIBILITY_FAILURE',
  CLEAR_PREVIEW: 'eligibility/CLEAR_PREVIEW',
};

export default EligibilityActionTypes;
